import _ from 'lodash';
import DefaultDialogController from 'utils/notifications/default-dialog-controller';

const mapStateToThis = ({ session, config, ui }) => {
  const { locale } = session;
  const { locales } = config;
  const { selectedLanguage } = ui;

  return {
    locale,
    locales,
    selectedLanguage,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'appFactory', '$timeout', 'Notifications', 'gettextCatalog')
class EditCategoryController extends DefaultDialogController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.language = this.language || this.selectedLanguage || this.locale;
    if (_.get(this, 'category.name')) {
      this.oldCategoryName = this.category.name;
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }

  submit() {
    this.form.$setSubmitted();
    if (this.form.$valid) {
      if (this.verifyOtherLanguages()) {
        this.Notifications.alertWarning(this.gettextCatalog.getString('Enter other language before submitting.'));
        return;
      }
      this.confirm({ category: this.category, oldCategoryName: this.oldCategoryName });
    }
  }

  onLanguageSelect(locale) {
    this.language = locale;
  }

  verifyOtherLanguages() {
    let otherLanguageError = false;
    this.locales.forEach((locale) => {
      if (!_.get(this, `category.fields[${locale.code}].description`)) {
        otherLanguageError = true;
      }
    });
    return otherLanguageError;
  }
}

export default EditCategoryController;



// WEBPACK FOOTER //
// ./src/modules/contact/components/manage-contact/edit-category-dialog/edit-category-dialog-controller.js